import { Sentry } from "../lib/sentry";
import type { ReactNode } from "react";

const FallbackComponent = () => (
  <div className="flex min-h-screen items-center justify-center p-8">
    <div className="max-w-md text-center">
      <h1 className="mb-2 text-xl font-semibold text-gray-900">Something went wrong</h1>
      <p className="mb-4 text-sm text-gray-600">
        An unexpected error occurred. Please refresh the page to try again.
      </p>
      <button
        onClick={() => window.location.reload()}
        className="rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
      >
        Refresh page
      </button>
    </div>
  </div>
);

interface Props {
  children: ReactNode;
}

export function SentryErrorBoundary({ children }: Props) {
  const ErrorBoundary = Sentry.ErrorBoundary;
  return (
    <ErrorBoundary fallback={<FallbackComponent />} showDialog={false}>
      {children}
    </ErrorBoundary>
  );
}
